import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import styles from "./Drawer.module.css";
function Drawer(props) {
  return (
    <Fragment>
      <div onClick={props.drawerHandle} className={styles.backDrop}></div>
      <div className={`${styles.drawer} drawer`}>
        <ul>
          <li>
            <NavLink onClick={props.drawerHandle} to="/">
              HOME
            </NavLink>
          </li>
          <li>
            <NavLink onClick={props.drawerHandle} to="/about">
              ABOUT ME
            </NavLink>
          </li>
          <li>
            <NavLink onClick={props.drawerHandle} to="/skills">
              SKILLS
            </NavLink>
          </li>
          <li>
            <NavLink onClick={props.drawerHandle} to="/experience">
              EXPERIENCE
            </NavLink>
          </li>
          <li>
            <NavLink onClick={props.drawerHandle} to="/portfolio">
              PORTFOLIO
            </NavLink>
          </li>
          <li>
            <NavLink onClick={props.drawerHandle} to="/contact">
              CONTACT
            </NavLink>
          </li>
        </ul>
      </div>
    </Fragment>
  );
}

export default Drawer;
